import { MediumText } from "pages/underwriterDashboard/styles.js";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StyledContainer } from "pages/underwriters/styles.js";
import { useMediaQuery } from "react-responsive";
import { GoBackButton } from "pages/buyers/components/goBackButton";
import { underwriterPdScoreSelector } from "data/selectors/underwriters";
import { getPdScore } from "data/actions/underwriters";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { StyledTab } from "pages/underwriterDashboard/clientSection/styles.js";
import PositiveAttributes from "./positiveAttributes.js";
import NegativeAttributes from "./negativeAttributes.js";
import ScatterPlot from "./scatterPlot.js";
import SemiCircleGauge from "./semiCirclePD.js";
import { SearchBar } from "pages/contractorDashboard/detailScreens/SearchBar.js";
import { useLocation } from "react-router-dom";
import { FunctionalButton } from "components/functionalButton";
import { updatedBulkPD } from "../../../../api/external_data";
import { SuccessPopup } from "../peerGroupAnalysis/SuccessPopup";
import { underwriteeListForAgentSelector } from "data/selectors/underwriters";
import { getUnderwriterListForAgent } from "data/actions/underwriters";
import { ReactComponent as DeleteIcon } from "assets/common/deleteIcon.svg";
import referrers from "../../../underwriterInsights/refererrs.json";

const ProbabilityOfDefault = ({ isUnderwriterInsights }) => {
  const isMobile = useMediaQuery({ maxWidth: 453 });
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const underwriterPdScoreData = useSelector(underwriterPdScoreSelector);
  const [selectTab, setSelectTab] = React.useState("1");
  const [riskValue, setRiskValue] = React.useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [desiredAccountData, setDesiredAccountData] = useState([]);
  let desiredAccountEntry = [];
  const location = useLocation();
  const referrer = new URLSearchParams(location.search).get("referrer");
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [testData, setTestData] = useState([]);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [brandingImageUrl, setBrandingImageUrl] = useState();

  const fileRef = useRef();
  const underwriteeListForAgentData = useSelector(
    underwriteeListForAgentSelector
  );

  useEffect(() => {
    if (underwriteeListForAgentData.length < 1) {
      dispatch(getUnderwriterListForAgent());
    }
  }, []);

  useEffect(() => {
    if (underwriteeListForAgentData) {
      setTestData(underwriteeListForAgentData);
    }
  }, [underwriteeListForAgentData]);

  const handleUpdatingPD = () => {
    const data = {
      account_id: location.state?.account_id,
      company_name: location.state?.company_name,
    };
    updatedBulkPD(data, onSuccessUpdatedBulkPD, () => {});
  };

  const handleUploadPD = () => {
    fileRef.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFileName(file.name);
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const jsonData = JSON.parse(e.target.result);
          setData([{
            ...jsonData.pd_data,
            AccountId: jsonData.pga_data.AccountId,
            Score: jsonData.pd_score,
            NegativeAttributes: JSON.stringify(jsonData.risk_attributes.NegativeAttributes),
            PositiveAttributes: JSON.stringify(jsonData.risk_attributes.PositiveAttributes),
          }]);
        } catch (error) {
          console.error("Error parsing JSON file:", error);
        }
      };
      reader.readAsText(file);
    }
  };

  const onSuccessUpdatedBulkPD = (res) => {
    setOpenSuccessPopup(true);
  };

  const handleDeleteData = () => {
    if (!isUnderwriterInsights) {
      return;
    }

    setData([]);
    setDesiredAccountData([]);
    setRiskValue(null);
    setUploadedFileName("");
    if (fileRef.current) {
      fileRef.current.value = "";
    }
  };

  const handleChange = (event, newValue) => {
    setSelectTab(newValue);
  };

  useEffect(() => {
    if (isUnderwriterInsights) {
      return;
    }

    if (underwriterPdScoreData.length < 1) {
      dispatch(getPdScore());
    }
  }, []);

  useEffect(() => {
    if (isUnderwriterInsights) {
      return;
    }

    if (underwriterPdScoreData) {
      setData(underwriterPdScoreData);
    }
  }, [underwriterPdScoreData]);

  useEffect(() => {
    if (desiredAccountEntry) {
    }
  }, [desiredAccountEntry]);

  useEffect(() => {
    const filteredData = searchQuery
      ? data.filter((item) =>
          item.AccountId.toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())
        )
      : data;
    setSearchResults(filteredData);
  }, [searchQuery, data]);

  const dataCount = searchResults.length;
  const dataTest = searchResults.map((item) => ({
    Score: item.Score,
    AnnualGrossContractIncome: item.AnnualGrossContractIncome,
    AccountId: item.AccountId,
    CompanyName: item.CompanyName,
  }));

  const handleDataPointClick = (dataPoint) => {
    const desiredAccountId = dataPoint.AccountId;
    desiredAccountEntry = [];
    desiredAccountEntry = data.find(
      (item) => item.AccountId === desiredAccountId
    );
    setDesiredAccountData(desiredAccountEntry);
    setRiskValue(dataPoint);
  };

  useEffect(() => {
    if (isUnderwriterInsights && referrer) {
      const imageUrl = referrers[referrer];
      if (imageUrl) {
        setBrandingImageUrl(imageUrl);
      }
    }
  }, [isUnderwriterInsights, referrer, referrers]);

  return (
    <StyledContainer isMobile={isMobile}>
      <GoBackButton />
      <br />
      {isUnderwriterInsights && <img src={brandingImageUrl} width="100px" />}
      <div style={{ display: "flex" }}>
        <div style={{ flex: "0 0 60%", marginRight: "0px" }}>
          <MediumText
            isMobile={isMobile}
            style={{
              fontSize: "28px",
              lineHeight: "20px",
              fontFamily: "SF Pro Text",
              color: "#1A051D",
              marginBottom: "20px",
              fontWeight: "600",
            }}
          >
            Probability Of Default
          </MediumText>
        </div>

        <div style={{ flex: "0 0 40%", marginTop: "0px", marginLeft: "100px" }}>
          {isUnderwriterInsights ? (
            data.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px 16px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                  maxWidth: "300px",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    color: "#333",
                    flex: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {uploadedFileName}
                </span>
                <button
                  onClick={handleDeleteData}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="Delete uploaded file"
                >
                  <DeleteIcon width={16} height={16} fill="#ff4444" />
                </button>
              </div>
            ) : (
              <FunctionalButton
                buttonTitle="Upload PD"
                handleButton={handleUploadPD}
                width="300px"
                height="48px"
                marginRight="0px"
                marginLeft="0px"
              />
            )
          ) : (
            <FunctionalButton
              buttonTitle="Send Request for Updating PD"
              handleButton={handleUpdatingPD}
              width="300px"
              height="48px"
              marginRight="0px"
              marginLeft="0px"
            />
          )}
        </div>
      </div>
      <SearchBar
        filteredData={data}
        setInternalSearchResults={setSearchResults}
        query={searchQuery}
        setQuery={setSearchQuery}
        internalSearch={true}
        searchPlaceHolder={"Search by Account Id"}
      />
      <br />
      <div style={{ display: "flex" }}>
        <div style={{ flex: "0 0 60%", marginRight: "20px" }}>
          <div>
            <div style={{ backgroundColor: "#FFFFFF", padding: "5px" }}>
              <ScatterPlot
                data={dataTest}
                totalAccounts={dataCount}
                onDataPointClick={handleDataPointClick}
              />
            </div>
          </div>
        </div>

        <div style={{ flex: "0 0 40%", marginTop: "-30px" }}>
          <div
            style={{
              fontSize: "18px",
              lineHeight: "20px",
              fontFamily: "SF Pro Text",
              color: "#1A051D",
              marginBottom: "10px",
              paddingLeft: "20px",
            }}
          >
            Insights & Recommendations
          </div>

          <div style={{ backgroundColor: "#FFFFFF" }}>
            <TabContext value={selectTab}>
              <TabList
                onChange={handleChange}
                variant="fullWidth"
                centered
                TabIndicatorProps={{ hidden: true }}
              >
                <StyledTab label="Positive Attributes" value="1" />
                <StyledTab label="Negative Attributes" value="2" />
              </TabList>

              <TabPanel value="1">
                {desiredAccountData && (
                  <PositiveAttributes data={desiredAccountData} />
                )}
                {desiredAccountData.length === 0 && (
                  <p>
                    Please select an Account from the graph to see the Positive
                    Attributes
                  </p>
                )}
              </TabPanel>
              <TabPanel value="2">
                {desiredAccountData && (
                  <NegativeAttributes data={desiredAccountData} />
                )}
                {desiredAccountData.length === 0 && (
                  <p>
                    Please select an Account from the graph to see the Negative
                    Attributes
                  </p>
                )}
              </TabPanel>
            </TabContext>
          </div>

          {riskValue && (
            <div
              style={{
                backgroundColor: "#FFFFFF",
                padding: "5px",
                marginTop: "20px",
              }}
            >
              <SemiCircleGauge data={riskValue} />
            </div>
          )}
        </div>
      </div>

      <SuccessPopup
        setOpenPopup={setOpenSuccessPopup}
        openPopup={openSuccessPopup}
        descriptionText={
          "The PD request has been sent to PledgX's support team."
        }
      />

      {/* Hidden file input for JSON upload */}
      <input
        type="file"
        ref={fileRef}
        onChange={handleFileChange}
        accept=".json"
        style={{ display: "none" }}
      />
    </StyledContainer>
  );
};

export default ProbabilityOfDefault;
